"use client"
import React, { useState } from 'react';
import Link from 'next/link';
import Image from "next/image";
import '@/app/main.css';

const ContactForm = () => {
    const [agree, setAgree] = useState(false); // ✅ define agree here
    const [name, setname] = useState('')
    const [email, setemail] = useState('')
    const [phone, setphone] = useState('')
    const [subject, setsubject] = useState('')
    const [message, setmessage] = useState('')
    const [thankYou, setThankYou] = useState(false);


    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(name, email, phone, subject, message)
        const data = { name, email, phone, subject, message };

        fetch('/api/send-email/', {
            method: 'POST',
            headers: {'Content-Type': 'application/json',},
            body: JSON.stringify(data),
        })

            .then(response => response.text())
            .then(data => {
                console.log('Success;', data);
                //alert("Thanks for Contact us");
                setname('')
                setemail('')
                setphone('')
                setsubject('')
                setmessage('')
                setThankYou(true); // show the thank you message
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        if (name === 'name') setname(value);
        else if (name === 'email') setemail(value);
        else if (name === 'phone') setphone(value);
        else if (name === 'subject') setsubject(value);
        else if (name === 'message') setmessage(value);
    };
    

    return (
        <div>
            <div id="__next">
                <main className="__className_6d1a03">
                    <div className="page-title-area">
                        <div className="d-table">
                            <div className="d-table-cell">
                                <div className="container">
                                     <div className="row justify-content-center align-items-center">
                                                <div className="col-6 col-md-12 ">
                                                    <div className="section-title  text-">
                                                    <h1 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">      Contact Eratec Solution – Your Trusted IT & Digital Marketing Partner
</h1>
                                                    <div className="bar" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
                                                    
                                                    </div>
                                                </div>
                                     </div>
                                </div>
                            </div>
                        </div>
                        <div className="shape1">
                            <Image alt="shape" loading="lazy" width="202" height="202" decoding="async" data-nimg="1" src="/shape1.svg" />
                        </div>
                        <div className="shape2 rotateme">
                            <Image alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" src="/shape2.svg" />
                        </div>
                        <div className="shape3">
                            <Image alt="shape" loading="lazy" width="28" height="28" decoding="async" data-nimg="1" src="/shape3.svg" />
                        </div>
                        <div className="shape4">
                            <Image alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" src="/shape4.svg" />
                        </div>
                        <div className="shape5">
                            <Image alt="shape" loading="lazy" width="182" height="146" decoding="async" data-nimg="1" src="/shape5.svg" />
                        </div>
                        <div className="shape6 rotateme">
                            <Image alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" src="/shape4.svg" />
                        </div>
                        <div className="shape7">
                            <Image alt="shape" loading="lazy" width="21" height="20" decoding="async" data-nimg="1" src="/shape4.svg" />
                        </div>
                        <div className="shape8 rotateme">
                            <Image alt="shape" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" src="/shape2.svg" />
                        </div>
                    </div>

                    <div className="contact-info-area ptb-80">
                        <div className="container">
          
       <div className="row text-center py-5">
       	 <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Get in Touch with us</h2>
         <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"> “We’re here to help businesses with website development, SEO, paid ads, eCommerce solutions, and more. Reach out to our Noida office or fill in the form below for quick assistance.”</p>
         </div>
      
      
      
      
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="contact-info-box">
                                        <div className="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                                <polyline points="22,6 12,13 2,6"></polyline>
                                            </svg>
                                        </div>
                                        <h3>Mail Here</h3>
                                        <p>
                                            <Link href="mailto:sales@eratecsolution.com">
                                                <span className="__cf_email__" data-cfemail="0362676e6a6d437077627177732d606c6e">sales@eratecsolution.com</span>
                                            </Link>
                                        </p>
                                        <p>
                                            <Link href="mailto:contact@eratecsolution.com">
                                                <span className="__cf_email__" data-cfemail="3b52555d547b484f5a494f4b15585456">contact@eratecsolution.com</span>
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="contact-info-box">
                                        <div className="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                                <circle cx="12" cy="10" r="3"></circle>
                                            </svg>
                                        </div>
                                        <h3>Visit Here</h3>
                                        <p>C-85, 4th Floor, C Block, Sector 2, Noida, Uttar Pradesh – 201301, India.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="contact-info-box">
                                        <div className="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path
                                                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                                                </path>
                                            </svg>
                                        </div>
                                        <h3>Call Here</h3>
                                        <p><Link href="tel:9625423124">+91 8802133490 </Link></p>
                                        <p><Link href="tel:7982022503">+91 7982022503</Link></p>
                                        
                                    </div>
                                </div>
                            </div>

                          { /*<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.591669050487!2d77.31070497457081!3d28.582021886374285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5deee35f953%3A0xaf7bcdc7b5d15966!2sEratec%20Solution%20-%20Website%20Development%20%7C%20Digital%20Marketing%20Agancy%20%7C%20Graphic%20Designing%20%7C%20Marketplace%20Services!5e0!3m2!1sen!2sin!4v1712640620265!5m2!1sen!2sin" className='iframe-map border-0' width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>*/}
                          <iframe 
                             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.591669050487!2d77.31070497457081!3d28.582021886374285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5deee35f953%3A0xaf7bcdc7b5d15966!2sEratec%20Solution%20-%20Website%20Development%20%7C%20Digital%20Marketing%20Agancy%20%7C%20Graphic%20Designing%20%7C%20Marketplace%20Services!5e0!3m2!1sen!2sin!4v1712640620265!5m2!1sen!2sin" 
                                className="iframe-map border-0" 
                               // width="100%" 
                               // height="450" 
                                allowFullScreen  // ✅ Corrected here
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade" // ✅ Also note camelCase here
                            ></iframe>


                          <div className="seo-content container py-5">
                            <h2 className="text-center">Connect with Eratec Solution</h2>
                            <p className="text-center">
                              Reach out to <strong>Eratec Solution</strong>, a trusted 
                              <strong> IT company in Noida and Delhi NCR</strong>. We specialize in 
                              <strong> SEO services</strong>, <strong>digital marketing</strong>, 
                              <strong>website development</strong>, <strong>eCommerce solutions</strong>, 
                              and <strong>mobile app development</strong>. Our team is here to help you 
                              grow your business with reliable and result-driven strategies.
                            </p>
                          </div>


                            <div className="contact-area ptb-80">
                                <div className="container">
                                    <div className="section-title">
                                        <h2>Send Us a Message</h2>
                                        <div className="bar"></div>
                                        <p>Need support or information? Our team is ready to assist.</p>
                                    </div>

                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12">

                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-lg-12 col-md-12">
                                                        <div className="form-group">
                                                            <input type="text" name="name" id="name" value={name} onChange={handleChange} placeholder="Your Name" className="form-control" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12">
                                                        <div className="form-group">
                                                            <input type="email" name="email" id="email" value={email} onChange={handleChange} placeholder="Your email address" className="form-control" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <input type="tel" name="phone" id="phone" value={phone} onChange={handleChange} placeholder="Your phone number" className="form-control" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <input type="text" name="subject" id="subject" value={subject} onChange={handleChange} placeholder="Your Subject" className="form-control" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12">
                                                        <div className="form-group">
                                                            <textarea name="message" id="message" value={message} onChange={handleChange} cols="30" rows="5" placeholder="Write your message..." className="form-control" required />
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" id="flexCheckDefault" checked={agree} onChange={() => setAgree(!agree)} value="" />
                                                            <label className="form-check-label" htmlFor="flexCheckDefault">By checking this, you agree to our <Link href={"/terms-conditions"}> Terms and Conditions</Link> &amp; <Link href={"/privacy-policy"}> Privacy policy</Link>.</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-sm-12">
                                                        <button 
                                                         onClick={() => window.location.href = '/thankyou_page'}
                                                        type="submit" className="btn btn-primary" disabled={!agree}>
                                                            Send Message
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>

                                        <div className="col-lg-6 col-md-12">
                                            <Image src="/contact-img.svg" alt="contact-us" loading="lazy" width="685" height="494" decoding="async" data-nimg="1" priority="" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default ContactForm
